import React from 'react'
import { NavLink } from 'react-router-dom';

import './nav-bar-icon.scss'

export const NavBarIcon = (icon) => (
  <div className="icon-container">
      <NavLink exact={true} to={icon.route} activeClassName="selected">
        <span>
          <i className={ icon.iconName }></i> {icon.text}
        </span>
      </NavLink>
  </div>
)
  
  
